import { render, staticRenderFns } from "./ServeIndex.vue?vue&type=template&id=12e907ec&scoped=true"
import script from "./ServeIndex.vue?vue&type=script&lang=js"
export * from "./ServeIndex.vue?vue&type=script&lang=js"
import style0 from "./ServeIndex.vue?vue&type=style&index=0&id=12e907ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e907ec",
  null
  
)

export default component.exports